import React, { useState, useCallback, useMemo } from "react";
import { useParams } from "react-router-dom";
import { PortifolioItem } from "../../../Interfaces/Portifolio/portifolioItem";
import { UsuarioLoginItens } from '../../../Interfaces/Usuario/UsuarioLoginItens';
import { PaginacaoItens } from '../../../Interfaces/shared/PaginacaoItens';
import { ModalItem } from "../../../Interfaces/shared/modalItem";
import { PersistirItens } from "../../../Interfaces/shared/persistirItens";
import { API_BASE_AGENDA_URL } from '../../../config/apiConfig';
import { useUsuarioLogado } from "../../../hooks/useUsuarioLogado";
import { GetPaginadoService } from "../../../services/shared/getPaginadoService";
import { DeleteService } from "../../../services/shared/deleteService";
import { GetByIdService } from "../../../services/shared/getByIdService";
import {
    ModalTexto, propertyLabelsColaborador, UrlBuscarPaginado, UrlPortifolio, UrlTipoPortifolioImagem, propertyLabelsLoja
} from '../../../constants/Portifolio/PortifolioConstant';
import { TipoUsuarioLojaId, TipoUsuarioColaboradorId } from '../../../constants/Usuario/usuarioConstant';
import { GrigViewItens } from "../../../Interfaces/shared/gridviewItens";
import { ResponseItem } from "../../../Interfaces/shared/ResponseItem";
import { TipoPortifolioImagemItem } from "../../../Interfaces/Portifolio/tipoPortifolioImagemItem";
import { useColaboradorData } from '../../../hooks/useColaboradorData';
import { useLojaData } from "../../../hooks/useLojaData";
import { useHiddenItem } from '../../../hooks/useHiddenItem';
import { Tooltip } from '@mui/material';
import { FaThList } from "react-icons/fa";
import { FaFolderOpen } from "react-icons/fa";
import PortifolioBusca from "./PortifolioSearch"
import GridViewLista from '../../../components/gridview';
import EditRoundedIcon from '@mui/icons-material/EditRounded';
import DeleteIcon from '@mui/icons-material/Delete';
import ModalGeneric from "../../../componentsGenerics/modalGeneric";
import PortifolioPersistir from './PortifolioForm';
import Banner from '../../../components/banner';
import Footer from '../../../components/footer';
import useUpdateGrid from "../../../hooks/useUpdateGrid";
import useUpdateFetch from '../../../hooks/useUpdateFetch';
import useFetchTipo from "../../../hooks/useFetchTipo";
import styles from "./Portifolio.module.css";




const PortifolioPageContent: React.FC = () => {
    const [useUsuarioLogadoItem, setUsuarioLogado] = useState<UsuarioLoginItens>();
    const [persistirItensList, setPersistirItensList] = useState<Array<PersistirItens<any>>>([]);
    const [resultadosBusca, setResultadosBusca] = useState<PaginacaoItens<PortifolioItem>>();
    const [portifolioitem, setPortifolio] = useState<PortifolioItem>();
    const [modalOpen, setModalOpen] = useState<ModalItem>();
    const [gridViewItens, setGridView] = useState<GrigViewItens<PortifolioItem> | undefined>(undefined);
    const [tipoPortifolioImagem, setTipoPortifolioImagem] = useState<Array<TipoPortifolioImagemItem>>([])
    const {urlParametro } = useParams();
    const [isHiddenItem, setIsHiddenItem] = useState(false);
    const parametroNormalizado = (urlParametro ?? "").trim().toLowerCase();

    useHiddenItem("persistir", "lista", isHiddenItem);

    const tipoUsuarioId =
        parametroNormalizado === "loja" ? TipoUsuarioLojaId : parametroNormalizado === "colaborador" ? TipoUsuarioColaboradorId : "";
    const tipoUsuarioResolvido = tipoUsuarioId || TipoUsuarioLojaId;

    const fetchPortifolioData = useCallback(async (tipoUsuarioId?: string, page: number = 1) => {

        const tipoUsuarioAtual = tipoUsuarioId || tipoUsuarioResolvido;
        const paginacao: PaginacaoItens<PortifolioItem> = {
            quantidadePagina: resultadosBusca?.quantidadePagina || 6,
            paginaAtual: page,
            totalPaginas: resultadosBusca?.totalPaginas || 1,
            total: resultadosBusca?.total || 0,
            objetoPesquisa: {},
            objetos: resultadosBusca?.objetos ?? []
        };

        if (!resultadosBusca || page !== undefined) {
            paginacao.objetos = [];

            paginacao.objetoPesquisa = resultadosBusca?.objetoPesquisa || {};
            paginacao.objetoPesquisa.tipoUsuarioId = Number(tipoUsuarioAtual);
            const response = await GetPaginadoService(paginacao, `${API_BASE_AGENDA_URL}${UrlBuscarPaginado}`);
            if (response) {
                setResultadosBusca(response ?? {});
            }
        }
    }, [resultadosBusca, tipoUsuarioResolvido]);

    const fetchTipoUsuariosImagens = useCallback(async () => {
        const tipoUsuarioAtual = tipoUsuarioResolvido;

        const tipoPortifolioImagensResponse = await GetByIdService(tipoUsuarioAtual, `${API_BASE_AGENDA_URL}${UrlTipoPortifolioImagem}`
        ) as ResponseItem<TipoPortifolioImagemItem>;
        setTipoPortifolioImagem(tipoPortifolioImagensResponse?.datas ?? []);
        await fetchPortifolioData(tipoUsuarioAtual);
    }, [tipoUsuarioResolvido, fetchPortifolioData]);

    const handleScrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    };

    const handleModalDesativarPortifolio = useCallback(async (id: number) => {
        const lojaRetorno = await DeleteService(id, `${API_BASE_AGENDA_URL}${UrlPortifolio}`) as ResponseItem<PortifolioItem>;
        if (lojaRetorno) {
            fetchPortifolioData(tipoUsuarioId);
        }
    }, [fetchPortifolioData, tipoUsuarioId]);

    const handleDeleteClick = useCallback(
        async (event: React.MouseEvent, portifolio?: any) => {
            event.preventDefault();
            const modalprops: ModalItem = {
                open: true,
                onClose: () => handleModalDesativarPortifolio(portifolio?.id),
                title: portifolio?.titulo ?? "",
                texto: ModalTexto,
            };
            setModalOpen(modalprops);
        },
        [handleModalDesativarPortifolio]
    );

    const handlePageChange = useCallback((event: React.ChangeEvent<unknown>, page: number) => {
        fetchPortifolioData(tipoUsuarioId, page);
    }, [fetchPortifolioData, tipoUsuarioId])

    const handleUpdateClick = useCallback(async (event: React.MouseEvent, portifolio?: any) => {
        event.preventDefault();
        const Id = portifolio?.id ?? 0;
        const retorno = await GetByIdService(Id, `${API_BASE_AGENDA_URL}${UrlPortifolio}`) as ResponseItem<PortifolioItem>;
        retorno.data = {
            ...retorno.data,
            tipoUsuarioId: Number(tipoUsuarioResolvido),
        };
        setPortifolio(retorno.data);
        handleButtonClickSalvar();
        handleScrollToTop();

    }, [tipoUsuarioResolvido]);
    const actionButtons = useMemo(() => ([
        {
            id: 1,
            label: 'Edit',
            icon: <EditRoundedIcon />,
            href: '#',
            class: "btn-busca",
            onClick: handleUpdateClick
        },
        {
            id: 2,
            label: 'Delete',
            icon: <DeleteIcon />,
            href: '/delete',
            class: "btn-danger",
            onClick: handleDeleteClick
        }
    ]), [handleUpdateClick, handleDeleteClick]);

    const fetchResultadoPesquisa = useCallback((resultados: PaginacaoItens<PortifolioItem>) => {
        setResultadosBusca(resultados);
    }, []);

    const handleResultadosBusca = (resultados: PaginacaoItens<PortifolioItem>) => {
        fetchResultadoPesquisa(resultados);
    };
    const gridViewItensMemo = useMemo(() => {
        if (resultadosBusca) {
            return {
                paginacao: resultadosBusca,
                propertyLabels: tipoUsuarioId === TipoUsuarioLojaId ? propertyLabelsLoja : propertyLabelsColaborador,
                onPageChange: handlePageChange,
                actionButtons: actionButtons,
            } as GrigViewItens<PortifolioItem>;;
        }
        return undefined;
    }, [resultadosBusca, actionButtons, handlePageChange, tipoUsuarioId]);

    const { fetchUsuarioLogado } = useUsuarioLogado();
    const { fetchColaboradorData } = useColaboradorData(async (id) => {
        await fetchPortifolioData(id);
    });
    const { fetchLojaData } = useLojaData(async (id) => { await fetchPortifolioData(id); });
    useUpdateFetch([
        async () => setUsuarioLogado(await fetchUsuarioLogado()),
        async () => {
            const loja = await fetchLojaData()
            setPersistirItensList(prev => [...prev, loja]);
        },
        async () => {
            const colaborador = await fetchColaboradorData();
            setPersistirItensList(prev => [...prev, colaborador]);
        },
        () => fetchPortifolioData(tipoUsuarioResolvido),
        fetchTipoUsuariosImagens
    ], [tipoUsuarioResolvido]);

    useFetchTipo(
        urlParametro ?? "", [() => fetchPortifolioData(tipoUsuarioResolvido), fetchTipoUsuariosImagens],
        TipoUsuarioLojaId,
        TipoUsuarioColaboradorId
    );


    useUpdateGrid(gridViewItensMemo, setGridView, [persistirItensList], () => {
        let isSave = persistirItensList.find(item => item.isSave)?.isSave;
        if (isSave) {
            persistirItensList.map(item => item.isSave = false)
            fetchPortifolioData(tipoUsuarioResolvido)
        }
    });

    const handleButtonClickSalvar = () => {
        setIsHiddenItem(true);
    }

    const handleButtonClickListar = () => {
        setIsHiddenItem(false);
    }

    const handleSaveSuccess = useCallback(() => {
        setIsHiddenItem(false);
    }, []);

    return (
        <div className={styles.root}>
            <div className={styles.banner}>
                <Banner usuarioLogado={useUsuarioLogadoItem} />
            </div>

            <div className={styles.pageContent}>
                <div className={`persistir ${styles.section}`}>
                    <div className={styles.actionBar}>
                        <button onClick={handleButtonClickListar} className={styles.actionButton} type="button">
                            <Tooltip title="listar">
                                <span style={{ display: 'inline-flex', alignItems: 'center', gap: '6px' }}>
                                    <FaThList />
                                </span>
                            </Tooltip>
                        </button>
                    </div>

                    <div className={styles.sectionBody}>
                        <PortifolioPersistir
                            persistirProps={{ item: portifolioitem, onSave: handleSaveSuccess }}
                            tiposPortifolioImagem={tipoPortifolioImagem}
                            persistirDropProps={persistirItensList}
                            tipoUsuario={tipoUsuarioId}
                        />
                    </div>
                </div>

                <div className={`lista ${styles.section}`}>
                    <div className={styles.actionBar}>
                        <button onClick={handleButtonClickSalvar} className={styles.openButton} type="button">
                            <Tooltip title="novo">
                                <span style={{ display: 'inline-flex', alignItems: 'center', gap: '6px' }}>
                                    <FaFolderOpen />
                                </span>
                            </Tooltip>
                        </button>
                    </div>

                    <div className={styles.sectionBody}>
                        <PortifolioBusca
                            selectItens={persistirItensList ?? []}
                            tipoUsuarioId={tipoUsuarioId}
                            onResultadosBusca={handleResultadosBusca}
                        />
                    </div>

                    <div className={styles.sectionBody}>
                        <div className={styles.listHeader}>
                            <h2>Lista</h2>
                            <p>Visualize e gerencie os portifólios cadastrados</p>
                        </div>
                        <div className={styles.gridWrapper}>
                            <GridViewLista gridviewProps={gridViewItens ?? {}} />
                        </div>
                    </div>
                </div>
            </div>

            <div className="modal">
                {modalOpen && <ModalGeneric modalProps={modalOpen} />}
            </div>

            <div className={styles.footer}>
                <Footer />
            </div>
        </div>
    )
}

const PortifolioPage: React.FC = () => {
    const { urlParametro } = useParams();

    return <PortifolioPageContent key={urlParametro ?? "portifolio"} />;
};

export default PortifolioPage;
